import { WidgetSize, WidgetType } from 'components/farm-dashboard/types'
import { LicensesType } from 'models/IUserData'
export const MILK_YIELD_TABLE_WIDGETS = [
	{
		id: WidgetType.MILK_YIELD_LINEAR_CHART,
		type: WidgetType.MILK_YIELD_LINEAR_CHART,
		size: WidgetSize.LARGE,
		license: LicensesType.IDENTIFICATION,
	},
	{
		id: WidgetType.ACTUAL_YIELD,
		type: WidgetType.ACTUAL_YIELD,
		size: WidgetSize.SMALL,
		license: LicensesType.IDENTIFICATION,
	},
	{
		id: WidgetType.AVG_MILK_YIELD,
		type: WidgetType.AVG_MILK_YIELD,
		size: WidgetSize.SMALL,
		license: LicensesType.IDENTIFICATION,
	},

	{
		id: WidgetType.REJECTED_MILK_YIELD,
		type: WidgetType.REJECTED_MILK_YIELD,
		size: WidgetSize.SMALL,
		license: LicensesType.IDENTIFICATION,
	},
]
